import React from 'react';

/**
 * Reusable modal wrapper component
 * Provides consistent overlay styling with backdrop blur and centered content
 * Used for full-screen modals like ProfileFull and SettingsOverlay
 */
function ModalWrapper({ onClose, children, height = 'h-[98%]', width = 'w-[98%]' }) {
  return (
    <div className="modalWrapperOuter fixed inset-0 z-[60] flex items-center justify-center pb-16" onClick={onClose}>
      {/* Backdrop blur overlay */}
      <div className="absolute inset-0 bg-foreground/40 backdrop-blur-sm" />
      {/* Modal content container */}
      <div onClick={(e) => e.stopPropagation()} className={`modalWrapperInner relative flex flex-col ${width} ${height} bg-card rounded-3xl shadow-2xl overflow-hidden`}>
        {children}
      </div>
    </div>
  );
}

export default ModalWrapper;
